import "./NotificationCard.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck, faCircleXmark } from '@fortawesome/free-solid-svg-icons'

const API_endpoint = "https://webdev.cse.buffalo.edu/hci/api/api/deekstra";

/*  Function:   acceptRequest
    Purpose:    Change the status of a connection to "accepted"
                Attached to a button on the notification card of a friend request
    Returns:    none
*/
async function acceptRequest(req) {
    // console.log(req.attributes.status);
    console.log("Before Patch:",req.id, req.attributes.status);
    const connectionObj = await fetch(`${API_endpoint}/connections/${req.id}`, {
        method: "PATCH",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        },
        body: JSON.stringify({
            attributes: {
                status: "accepted",
            }
        })
    });
    const Connection = await connectionObj.json();
    console.log("After Patch:", Connection.id, Connection.attributes.status);
}

/*  Function:   rejectedRequest
    Purpose:    Delete the connection between the two users
                Attached to a button on the notification card of a friend request
    Returns:    none
*/
async function rejectRequest(req) {
    console.log("Deleting:", req.id);
    const connectionObj = await fetch(`${API_endpoint}/connections/${req.id}`, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem("token")
        },
    });
    // const Connection = await connectionObj.json();
    // console.log("Deleted: ", Connection, Connection);
}

function NotificationCard(props) {
    return (
        <div className="notif-card" key={props.id}>
            <div className = "notif-card-type"> Friend Request </div>
            <div className = "notif-card-body">
                <img
                    className="notif-card-picture"
                    src={props.fromUser.attributes.profile_pic_src}
                    alt= "Profile Picture"
                />
                <div className="notif-card-sender">
                    {props.fromUser.attributes.name.toString()}
                </div> 
            </div>
            <div className = "notif-card-buttons">
                    <button type="button" className="notif-accept-button" onClick={() => acceptRequest(props)}> <FontAwesomeIcon icon={faCircleCheck} /> &nbsp;Accept</button>
                    <button type="button" className="notif-reject-button" onClick={() => rejectRequest(props)}> <FontAwesomeIcon icon={faCircleXmark} /> &nbsp;Reject</button>
            </div>
        </div>
    )};
// }
export default NotificationCard;